import { API_DEV } from "constants/api";
import { SUBMISSION_STATE_WON } from "constants/dbValues";

import { header, handleAPIResult, serialize, formatMaterialFilters } from "utils";
import { selectService } from "./select.service";

export const submissionService = {
  list,
  get,
  create,
  update,
  followUp,
  powerBiUrl,
  listQuestions,
  listSubmissions,
};

function list(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/submissions?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function get(id) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/submissions/" + id, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function create(submission) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      submission: submission,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/submissions", postInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function update(submission) {
  const patchInfo = {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      submission: submission,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/submissions/" + submission.id, patchInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function followUp(id) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/submissions/" + id + "/follow_up", postInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function listQuestions(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/questions?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function listSubmissions(filtersUndecided = {}, filtersDecided = {}, excludeStates = []) {
  const { SubmissionState: tmpStates } = await selectService.list(["SubmissionState"]);
  const states = tmpStates.filter((s) => excludeStates.indexOf(s.id) === -1);

  const submissionsUndecided = await submissionService.list({
    submission_state_id: states.filter((s) => s.id !== SUBMISSION_STATE_WON).map((s) => s.id),
    ...filtersUndecided,
  });

  const submissionsDecided = await submissionService.list({
    submission_state_id: SUBMISSION_STATE_WON,
    ...filtersDecided,
  });

  return {
    submissions: [...submissionsUndecided, ...submissionsDecided],
    states,
  };
}

//Retourne l'url pour power bi
function powerBiUrl() {
  return API_DEV + "/submissions";
}
